import React from 'react';
import {Pressable, StyleSheet, Text, View} from 'react-native';
import {useTranslation} from 'react-i18next';
import PompiLogo from '../../assets/PompiImage.svg';
import {colors, fonts, radii, spacing, typography} from '../../config/theme';
import {DESKTOP_SIDEBAR_WIDTH} from '../../utility/useDesktopLayout';

// Desktop web replacement for the bottom tab bar: the logo on top and one
// row per tab. Used as the Tab.Navigator `tabBar` with tabBarPosition 'left'.
// `tabs` is the TABS map from Navigation.js ({Icon, label} per route).
const DesktopSidebar = ({state, navigation, tabs}) => {
  const {t} = useTranslation();
  return (
    <View style={styles.sidebar}>
      <View style={styles.logo}>
        <PompiLogo width={108} height={103} />
      </View>
      <View style={styles.items} accessibilityRole="tablist">
        {state.routes.map((route, index) => {
          const {Icon, label} = tabs[route.name];
          const focused = state.index === index;
          const onPress = () => {
            const event = navigation.emit({
              type: 'tabPress',
              target: route.key,
              canPreventDefault: true,
            });
            if (!focused && !event.defaultPrevented) {
              navigation.navigate(route.name, route.params);
            }
          };
          return (
            <Pressable
              key={route.key}
              onPress={onPress}
              accessibilityRole="tab"
              accessibilityState={{selected: focused}}
              accessibilityLabel={t(label)}
              style={({hovered}) => [
                styles.item,
                hovered && !focused && styles.itemHover,
                focused && styles.itemActive,
              ]}>
              <Icon
                width={22}
                height={22}
                color={focused ? colors.primary : colors.textMuted}
              />
              <Text
                numberOfLines={1}
                style={[styles.label, focused && styles.labelActive]}>
                {t(label)}
              </Text>
            </Pressable>
          );
        })}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  sidebar: {
    width: DESKTOP_SIDEBAR_WIDTH,
    height: '100%',
    paddingHorizontal: spacing.md,
    paddingVertical: spacing.lg,
    backgroundColor: colors.surface,
    borderRightWidth: 1,
    borderRightColor: colors.border,
  },
  logo: {
    alignItems: 'center',
    marginBottom: spacing.xl,
  },
  items: {gap: spacing.xs},
  item: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: spacing.md,
    paddingVertical: spacing.md,
    paddingHorizontal: spacing.md,
    borderRadius: radii.sm,
  },
  itemHover: {backgroundColor: colors.surfaceMuted},
  itemActive: {backgroundColor: colors.mintLine},
  label: {
    ...typography.labelLg,
    letterSpacing: 0,
    color: colors.textMuted,
  },
  labelActive: {
    fontFamily: fonts.bold,
    color: colors.primary,
  },
});

export default DesktopSidebar;
